import React from 'react';
import { func } from 'prop-types';
import cn from 'classnames';

import { ReactComponent as Check } from '~assets/circle-check.svg';
import { companyPropTypes } from '~propTypes/company';

import styles from './styles.module.scss';

function ElectronicReceiptItem({ company, onSelectCompany }) {
  const handleSelect = () => onSelectCompany(company);

  return (
    <button
      type="button"
      className={cn('m-bottom-3', styles.element, {
        [styles.active]: company.active
      })}
      onClick={handleSelect}>
      {company?.active && (
        <p className={`text-dusty-gray ${styles.highlightItem}`}>
          <Check className={styles.highlightItem} />
        </p>
      )}

      <div className="semi-bold">{company.commercialName}</div>
      <div>{company.identificationNumber}</div>
    </button>
  );
}

ElectronicReceiptItem.propTypes = {
  onSelectCompany: func.isRequired,
  company: companyPropTypes
};

export default ElectronicReceiptItem;
